<!--
 * @Descripttion: 异步选择器文本值获取
 * @version: 1.0
 * @Author: sakuya
 * @Date: 2021年8月3日15:53:37
 * @LastEditors:
 * @LastEditTime:
-->

<template :loading="loading">
    <span>{{modelText}}</span>
</template>

<script>
import config from "@/config/select";

export default {
    props: {
        apiObj: { type: Object, default: () => { } },
        dic: { type: String, default: "" },
        params: { type: Object, default: () => ({}) },
    },
    data () {
        return {
            dicParams: this.params,
            loading: false,
            options: [],
            props: config.props,
            modelText: ''
        };
    },
    created () {
        this.getRemoteData();
    },
    watch: {
        "$attrs.modelValue": {
            handler (val) {
                if (val) {
                    this.getText()
                } else {
                    return
                }

            },
        }
    },
    methods: {
        //获取数据
        async getRemoteData () {
            this.loading = true;
            this.dicParams[config.request.name] = this.dic;
            var res = {};
            if (this.apiObj) {
                res = await this.apiObj.get(this.params);
            } else if (this.dic) {
                res = await config.dicApiObj.get(this.params);
            }
            var response = config.parseData(res);
            this.options = response.data;
            this.loading = false;
            this.getText()
        },

        getText () {
            let val = this.$attrs.modelValue
            if (this.options && this.options.length) {
                var obj = this.options.find(function (x) {
                    return x.itemValue == val
                })
                this.modelText = obj.itemText
            } else {
                return
            }

        }
    },
};
</script>

<style scoped>
.sc-select {
    display: inline-block;
    position: relative;
}
.sc-select-loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 100;
    border-radius: 5px;
    border: 1px solid #ebeef5;
    display: flex;
    align-items: center;
    padding-left: 10px;
}
.sc-select-loading i {
    font-size: 14px;
}

[data-theme='dark'] .sc-select-loading {
    background: var(--el-color-white);
    border-color: var(--el-border-color-base);
}
</style>
